"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = require("react-dom");
// tslint:disable-next-line:no-any
function isNumber(val) {
    return ({}).toString.call(val) === '[object Number]';
}
exports.isNumber = isNumber;
// tslint:disable-next-line:no-any
function has(val, key) {
    if (val === null || val === undefined) {
        return false;
    }
    return hasOwnProperty.call(val, key);
}
exports.has = has;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
// tslint:disable-next-line:no-any
function toObject(val) {
    if (val === null || val === undefined) {
        throw new TypeError('assign cannot be called with null or undefined');
    }
    return Object(val);
}
// tslint:disable-next-line:no-any
var assign = Object.assign || function (target, source) {
    // tslint:disable-next-line:no-any
    var from;
    var to = toObject(target);
    // tslint:disable-next-line:no-any
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
            }
        }
        // tslint:disable-next-line:no-any
        if (Object.getOwnPropertySymbols) {
            // tslint:disable-next-line:no-any
            symbols = Object.getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                }
            }
        }
    }
    return to;
};
exports.assign = assign;
// tslint:disable-next-line:no-any
function measureWidth(componentOrElement) {
    var domNode = ReactDOM.findDOMNode(componentOrElement);
    var rect = domNode.getBoundingClientRect();
    return Math.ceil(rect.right - rect.left);
}
exports.measureWidth = measureWidth;
function measureScrollbarWidth(div) {
    var value = div.style.overflowY;
    div.style.overflowY = 'scroll';
    var scrollbarWidth = div.offsetWidth - div.clientWidth;
    div.style.overflowY = value;
    return scrollbarWidth;
}
exports.measureScrollbarWidth = measureScrollbarWidth;
function assert(condition, message) {
    if (!condition) {
        throw new Error(message);
    }
}
exports.assert = assert;
//# sourceMappingURL=Utils.js.map